<div class="fc-common-panel-wrapper">
    <div class="fc-common-panel-header">
        <h2 class="template-icon">
            <span class="fc-common-panel-header-title">
                {{ isShowAcknowledgeBtn() ? 'Read & Acknowledge' : 'View Document' }}
            </span>
        </h2>
        <span class="fc-common-panel-header-close-btn"
              (click)="closeDialog()"></span>
    </div>
    <div class="fc-common-panel-body">
        <div class="row">
            <!-- left section -->
            <div class="column-1">
                <div *ngIf="!isEnableBulkAck && !isPegasus" class="sub-header">
                        <span class="file-name">{{fileName}}</span>
                        <span class="icon-download" (click)="downloadSingleDoc({fileName: fileName}, true)"></span>
                </div>
                <div class="document-wrapper" [ngClass]="{'has-left': isEnableBulkAck || isPegasus}">
                    <div *ngIf="isEnableBulkAck && !isPegasus && isShowAcknowledgeBtn()" class="left-column-section">
                        <div class="left-column-header">Select Document(s)</div>
                        <div class="left-column-item add-more-btn add-more-icon"
                        (click)="addMoreDocuments()">
                            <span class="add-more-documents-text">Add More Documents</span>
                        </div>
                        <div class="left-column-item"
                             *ngFor="let document of showDocuments | sortBy: 'asc':'title'; index as i"
                             [ngClass]="{'left-column-item-standard-doc' : !isPegasus, 'active': selectedDocIndex === i}">
                            <span class="document-title" (click)="loadSelectDocument(i)">{{document.title}}</span>
                            <span class="icon-download" (click)="downloadSingleDoc(document, false)"></span>
                        </div>
                    </div>
                    <div *ngIf="isPegasus" class="left-column-section">
                        <div class="left-column-header">Select Document(s)</div>
                        <div *ngIf="isEnableBulkAck && isShowAcknowledgeBtn()" class="left-column-item add-more-btn add-more-icon"
                             (click)="addMoreDocuments();docCaseAccordionRef.openFirstItem()">
                            <span class="add-more-documents-text">Add More Cases</span>
                        </div>
                        <fc-accordion #docCaseAccordionRef>
                            <fc-accordion-item
                                    id="doc-case-item-{{i}}"
                                    name="{{case && case.length && (case[0]?.srCaseID || case[0]?.caseNumber + ' - ' + case[0]?.caseVersion)}}"
                                    class="doc-case-wrapper"
                                    [expanded]="i === 0"
                                    [ngClass]="{'selected' : selectedCaseIndex === i}"
                                    (toggle)="toggleDocCaseItem($event, i)"
                                    *ngFor="let case of showDocuments | sortByCase: 'asc': 'caseNumber'; index as i">
                                <div class="left-column-item"
                                     [ngClass]="{'left-column-item-document-cases' : isPegasus, 'active': (selectedDocIndex === documentIndex) && (selectedCaseIndex === i)}"
                                     *ngFor="let document of case | sortBy: 'asc':'title'; index as documentIndex">
                                    <span class="document-title" (click)="loadSelectDocument(documentIndex, i)">{{document.title}}</span>
                                    <span class="icon-download" (click)="downloadSingleDoc(document, false)"></span>
                                </div>
                            </fc-accordion-item>
                        </fc-accordion>
                    </div>
                    <div class="preview-document" [ngClass]="{'has-left': isEnableBulkAck || isPegasus}">
                        <div *ngIf="isEnableBulkAck || isPegasus" class="sub-header">
                            <span class="file-name">{{fileName}}</span>
                            <span class="icon-download" (click)="downloadSingleDoc({fileName: fileName}, true)"></span>
                        </div>
                        <div [hidden]="loadDocumentStatus !== 'SUCCESS'" #viewer class="viewer"></div>
                        <div *ngIf="loadDocumentStatus === 'IN_PROGRESS'" class="not-available-viewer">
                            <p class="text-below-icon">Loading document ...</p>
                        </div>
                        <div *ngIf="loadDocumentStatus === 'ERROR'" class="not-available-viewer">
                            <p class="no-document-icon"></p>
                            <p class="text-below-icon">{{noDocumentMessage}}</p>
                        </div>
                    </div>
                </div>
                
            </div>
            <!-- right section -->
            <div class="column-2"
                 [ngClass]="{'expanding': expandAttributePanel}">
                <div class="arrow-wrapper">
                    <div [ngClass]="{'collapse-icon': !expandAttributePanel, 'expand-icon' : expandAttributePanel}"
                         (click)="expandAttributePanel = !expandAttributePanel">
                    </div>
                </div>
                <fc-accordion>
                    <fc-accordion-item
                            id="attributes"
                            name="Attributes"
                            [expanded]="true">
                        <div class="document-attributes"
                             *ngIf="!isPegasus">
                            <div class="attribute-item">
                                <span class="attribute-label">
                                    Category
                                </span>
                                <div class="attribute-value">
                                    {{ dialogData?.requestParams?.categoryLabel || attributes?.categoryId }}
                                </div>
                            </div>
                            <div class="attribute-item">
                                <span class="attribute-label">
                                    Document Name
                                </span>
                                <div class="attribute-value">
                                    {{ attributes.title }}
                                </div>
                            </div>
                            <div class="attribute-item">
                                <span class="attribute-label">
                                    Version
                                </span>
                                <div class="attribute-value">
                                    {{ attributes?.version ? attributes.version : 'N/A' }}
                                </div>
                            </div>
                            <div class="attribute-item">
                                <span class="attribute-label">
                                    Version Date
                                </span>
                                <div class="attribute-value">
                                    {{ attributes?.versionDate ? (attributes.versionDate | date: 'dd-MMM-y') : 'N/A' }}
                                </div>
                            </div>
                            <div class="attribute-item">
                                <span class="attribute-label">
                                    Published Date
                                </span>
                                <div class="attribute-value">
                                    {{ attributes.publishDate | date: 'dd-MMM-y' }}
                                </div>
                            </div>
                            <div class="attribute-item">
                                <span class="attribute-label">
                                    Language
                                </span>
                                <div class="attribute-value">
                                    {{ translateLanguage(attributes.language) }}
                                </div>
                            </div>
                            <div class="attribute-item">
                                <span class="attribute-label">
                                    Site
                                </span>
                                <div class="attribute-value">
                                    {{ attributes.sites ? attributes.sites : 'N/A'}}
                                </div>
                            </div>
                        </div>
                        <div class="document-attributes"
                             *ngIf="isPegasus">
                            <div class="attribute-item">
                                <span class="attribute-label">
                                    Category
                                </span>
                                <div class="attribute-value">
                                    {{ dialogData?.requestParams?.categoryLabel || attributes.categoryId }}
                                </div>
                            </div>
                            <div class="attribute-item" *ngIf="attributes?.categoryId === 'pegasus_safety_letter'">
                                <span class="attribute-label">
                                    Case Number
                                </span>
                                <div class="attribute-value">
                                    {{ attributes.caseNumber }}
                                </div>
                            </div>
                            <div class="attribute-item" *ngIf="attributes?.categoryId === 'pegasus_safety_letter'">
                                <span class="attribute-label">
                                    Case Version
                                </span>
                                <div class="attribute-value">
                                    {{ attributes.caseVersion }}
                                </div>
                            </div>
                            <div class="attribute-item" *ngIf="attributes?.categoryId === 'pegasus_line_listing'">
                                <span class="attribute-label">
                                    Line Listings Number
                                </span>
                                <div class="attribute-value">
                                    {{ attributes.srCaseID }}
                                </div>
                            </div>
                            <div class="attribute-item">
                                <span class="attribute-label">
                                    Report Type
                                </span>
                                <div class="attribute-value">
                                    {{ attributes.reportType}}
                                </div>
                            </div>
                            <div class="attribute-item">
                                <span class="attribute-label">
                                    Document Name
                                </span>
                                <div class="attribute-value">
                                    {{ attributes.title }}
                                </div>
                            </div>
                            <div class="attribute-item">
                                <span class="attribute-label">
                                    Published Date
                                </span>
                                <div class="attribute-value">
                                    {{ attributes.publishDate | date: 'dd-MMM-y' }}
                                </div>
                            </div>
                            <div class="attribute-item" *ngIf="attributes?.categoryId === 'pegasus_line_listing'">
                                <span class="attribute-label">
                                    Start Date
                                </span>
                                <div class="attribute-value">
                                    {{ attributes.lineListingStartDate | date: 'dd-MMM-y' }}
                                </div>
                            </div>
                            <div class="attribute-item" *ngIf="attributes?.categoryId === 'pegasus_line_listing'">
                                <span class="attribute-label">
                                    End Date
                                </span>
                                <div class="attribute-value">
                                    {{ attributes.lineListingEndDate | date: 'dd-MMM-y' }}
                                </div>
                            </div>
                            <div class="attribute-item">
                                <span class="attribute-label">
                                    Language
                                </span>
                                <div class="attribute-value">
                                    {{ translateLanguage(attributes.language) }}
                                </div>
                            </div>
                            <div class="attribute-item">
                                <span class="attribute-label">
                                    Site
                                </span>
                                <div class="attribute-value">
                                    {{ attributes.sites }}
                                </div>
                            </div>
                        </div>
                    </fc-accordion-item>
                </fc-accordion>
            </div>
        </div>
    </div>
    <div class="fc-common-panel-footer">
        <div class="fc-common-panel-footer-buttons">
            <button class="fc-common-button modal-button outline-btn float-left non-margin-left"
                    type="button"
                    (click)="closeDialog()">
                <span>Cancel</span>
            </button>
            <button *ngIf="isShowAcknowledgeBtn()"
                    class="fc-common-button modal-button dark-green primary-button" 
                    (click)="btnAcknowledge()">
                <span>Acknowledge</span>
            </button>
        </div>
    </div>
</div>
